import { _get } from 'frontcore/utils/communications/apiClient'
import { Perimeter, PerimeterAPIClient, PerimeterAPIResponse } from 'frontcore/presentation/perimeter-finder/domain/types'
import { URL_BASE_PERIMETERS } from 'frontcore/presentation/perimeter-finder/constants'

export default class PerimeterHttpAPI implements PerimeterAPIClient {
  async request (): Promise<PerimeterAPIResponse[]> {
    const url = `${URL_BASE_PERIMETERS}/?format=info`
    const perimeter = await _get(url)
    return perimeter as PerimeterAPIResponse[]
  }

  async retrieve (id: number): Promise<PerimeterAPIResponse> {
    const url = `${URL_BASE_PERIMETERS}/${id}/`
    const perimeter = await _get(url)
    return perimeter as PerimeterAPIResponse
  }


  transformToPerimeter (perimeterAPIResponse: PerimeterAPIResponse): Perimeter {
    return new Perimeter({
      id: perimeterAPIResponse.id,
      description: perimeterAPIResponse.description,
      name: perimeterAPIResponse.name,
      media: perimeterAPIResponse.media,
      parent: perimeterAPIResponse.parent,
      pattern: perimeterAPIResponse.pattern,
      externalId: perimeterAPIResponse.external_id,
      factoryURL: perimeterAPIResponse.factory_url,
    })
  }

  transformToPerimeters (perimeterAPIResponses: PerimeterAPIResponse[]): Perimeter[] {
    return perimeterAPIResponses.map(response => this.transformToPerimeter(response))
  }
}
